module.exports = __webpack_public_path__ + "img/default-thumbnail.37c0f2fb.png";